// ZIP-tier → delivery fee resolver. Shared between the homepage Delivery
// Calculator and the checkout (Cart) page so a customer can compute the fee
// from either entry point.

const LOCAL_ZIPS = new Set([
  "11432", "11433", "11434", "11435", "11436", "11423", "11451",
  "11418", "11419", "11420", "11421", "11422",
]);

const MID_ZIPS = new Set([
  "11354", "11355", "11356", "11357", "11358", "11361", "11362", "11363", "11364",
  "11365", "11366", "11367", "11368", "11369", "11370", "11371", "11372", "11373",
  "11374", "11375", "11377", "11378", "11379", "11385",
  "11101", "11102", "11103", "11104", "11105", "11106", "11109",
  "11411", "11412", "11413", "11414", "11415", "11416", "11417",
  "11424", "11425", "11426", "11427", "11428", "11429",
  "11207", "11208", "11212", "11221", "11222", "11233", "11236", "11237", "11238", "11239",
]);

export const classifyZip = (raw) => {
  const zip = String(raw || "").trim();
  if (!/^\d{5}$/.test(zip)) return null;
  if (LOCAL_ZIPS.has(zip)) {
    return { tier: "local", fee: 25, title: "Local Delivery", area: "Jamaica & immediate Queens" };
  }
  if (MID_ZIPS.has(zip)) {
    return { tier: "mid", fee: 55, title: "Mid-Range Delivery", area: "Wider Queens / Brooklyn borders" };
  }
  const n = Number(zip);
  if (n >= 10001 && n <= 10282) {
    return { tier: "outer", fee: 95, title: "Outer Zone Delivery", area: "Manhattan" };
  }
  if (n >= 10451 && n <= 10475) {
    return { tier: "outer", fee: 95, title: "Outer Zone Delivery", area: "Bronx" };
  }
  if (n >= 11201 && n <= 11256) {
    return { tier: "outer", fee: 95, title: "Outer Zone Delivery", area: "Far Brooklyn" };
  }
  if (n >= 10301 && n <= 10314) {
    return { tier: "outer", fee: 95, title: "Outer Zone Delivery", area: "Staten Island" };
  }
  if (
    (n >= 11020 && n <= 11099) ||
    (n >= 11501 && n <= 11599) ||
    (n >= 11801 && n <= 11899)
  ) {
    return { tier: "li", fee: 95, title: "Long Island Delivery", area: "Nassau County" };
  }
  if (n >= 11700 && n <= 11799) {
    return { tier: "li", fee: 125, title: "Long Island Delivery", area: "Western Suffolk County" };
  }
  if (n >= 11900 && n <= 11999) {
    return { tier: "unknown", fee: null, title: "Custom Quote Needed", area: "Eastern Suffolk / East End" };
  }
  return { tier: "unknown", fee: null, title: "Custom Quote Needed", area: "" };
};
